<template>
  <div>
   <div class="fixed z-50 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
​
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
​
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-md w-full">
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start">
            <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10">
              <svg class="h-6 w-6 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
              <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                Account Detail
              </h3>
              <div class="mt-2">
                <p>Account: #{{protest_request.user_property.account_no}}</p>
                <p>Email: {{protest_request.user_property.user.email}}</p>
                <p>SignUp: {{protest_request.user_property.user.first_name + " " + protest_request.user_property.user.last_name }}</p>
                <p>Owner Name: {{protest_request.user_property.Owner_Name}}</p>
                <p>Mailing Address: {{protest_request.user_property.Owner_Address}}</p>
                <p>Report PDF Approval: {{protest_request.photo_addendum_approval}}</p>
                <p>Finalized: {{protest_request.finalized_at}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse">
          <button @click="closeApproveModal()" type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:mt-0 sm:ml-3 sm:w-auto text-sm">
            Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { siteUrl } from '../../config/base';
export default {
props :["protest_request_uid","protest_request"],
  data() {
    return {
        comment:'',
    };
  },
  created(){
  },
  methods: {
      closeApproveModal(){
          this.$emit('close-account-info-modal');
      }
  }
};
</script>

<style scoped>
</style>
